export default __webpack_public_path__ + "static/media/pic-1.6c441adc.jpg";